/**
 * Function to convert a date to a date string in the format DD.MM.YYYY
 *
 * @param date - The date to format
 */
export const displayFormatDate = (date: Date): string => {
	return date.toLocaleDateString('no-NB', { dateStyle: 'short' })
}
